// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            color: "common.ui15",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-bottom: 5px;
            `,
        },
        css: css`
            flex-wrap: wrap;
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("common.ui15")};
            }
            ${StyledButton}:hover > ${TypographyStyle} {
                color: ${color("common.ui1")};
            }
        `,
        extendedStyles: {
            tooltipContent: {
                css: css`
                    padding: 0;
                    min-width: 180px;
                `,
            },
        },
    },
} as xBaseTheme["breadcrumbs"];
